import { ENV_OPTIONS, Environment } from './types/environment.type';

function parseBooleanVariable(value: unknown): boolean {
  if (typeof value === 'string') {
    return ['true', '1'].includes(value.toLowerCase());
  }

  return false;
}

function getEnvFromServerUrl(url: string): ENV_OPTIONS {
  switch (url) {
    case 'https://dev.gosimplr.com':
      return ENV_OPTIONS.DEV;
    case 'https://qa.gosimplr.com':
      return ENV_OPTIONS.QA;
    case 'https://aqa.gosimplr.com':
      return ENV_OPTIONS.AQA;
    case 'https://app.gosimplr.com':
      return ENV_OPTIONS.PROD;
    default:
      return ENV_OPTIONS.DEV;
  }
}

const environment: Environment = {
  sentry: {
    dsn: process.env.SENTRY_DSN,
    release: process.env.SENTRY_RELEASE,
    enabled: (process.env.SENTRY_ENABLED || '').toUpperCase() === 'TRUE',
    sentryEnv: process.env.SENTRY_ENV,
  },
  fullStory: {
    orgId: process.env.FULLSTORY_ORGID,
    isDevMode: parseBooleanVariable(process.env.FULLSTORY_DEV_MODE_ENABLED),
  },
  nodeEnv: process.env.NODE_ENV,
  currentEnv: getEnvFromServerUrl(process.env.PUBLIC_SERVER_DOMAIN || ''),
  publicUrl: process.env.PUBLIC_URL || '',
  publicServerDomain: process.env.PUBLIC_SERVER_DOMAIN || '',
  publicServerUrlPrefix: '/chat-api',
  localDevServerDomain: process.env.LOCAL_DEV_SERVER_DOMAIN || null,
  makeRequestTimeoutInMs: Number(process.env.MAKEREQUEST_TIMEOUT_IN_MS) || 50000, // using 50s as default here because AWS ELB has default of 60s
  analyticsDevMode: parseBooleanVariable(process.env.ANALYTICS_DEV_MODE),
  verizonPieUrl: process.env.VERIZON_PIE_URL,
  widgetServicesBaseUrl: process.env.NX_PUBLIC_WIDGET_SERVICES_BASE_URL,
  eventIngestionPipelineKey: process.env.EVENT_INGESTION_PIPELINE_KEY,
  eventIngestionPipelineUrl: process.env.EVENT_INGESTION_PIPELINE_URL,
};

export default environment;
